export const REACT_APP_API_URL = 'https://api.openweathermap.org/data/2.5'
export const REACT_APP_API_KEY = '144d60f59236b6794ebea41154cf9101'